import { Breakpoint, TableMenuHeading } from "@enxcs/dap-ui-stratos";

export const createAttendeesTableHeadings = (t: (key: string) => string): TableMenuHeading[] => {
  return [{ content: t("prepareModal.guestsStep.table.headers.name"), breakpoint: Breakpoint.M }];
};
